import {useEffect} from 'react';
import {dispatcher} from '@netx/core-next/instance/dispatcher';

export type UseSessionTickleParams = {
	disabled?: boolean;
	key: string;
};

export const useSessionTickle = ({
	disabled = false,
	key = 'audio',
}: UseSessionTickleParams) => {
	useEffect(() => {
		if (disabled) return;
		dispatcher.trigger('session:tickle:add', key);
		return () => {
			dispatcher.trigger('session:tickle:remove', key);
		};
	}, [disabled, key]);
};

export default useSessionTickle;
